var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7 0.285839L21.7 10.0873C21.8919 10.2754 22 10.5327 22 10.8014V22.881C22 23.1571 21.7761 23.381 21.5 23.381H14.5C14.2239 23.381 14 23.1571 14 22.881V17.3813C14 15.7837 12.7511 14.4777 11.1763 14.3864L11 14.3813C9.40232 14.3813 8.09634 15.6303 8.00509 17.2051L8 17.3813V22.881C7.99998 23.1571 7.77613 23.381 7.5 23.381L0.5 23.3813C0.25454 23.3813 0.0503841 23.2045 0.00803813 22.9712L0 22.8813V10.8014C0 10.5327 0.108129 10.2754 0.300019 10.0873L10.3 0.285839C10.6889 -0.0952795 11.3111 -0.0952795 11.7 0.285839Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.20b9cdb6fdecf112737291c48db2e2b2.svg";
export { ForwardRef as ReactComponent };